import React from 'react';
import { AuthSlideshow } from './AuthSlideshow';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex bg-white">
      {/* Left side - Slideshow */}
      <div className="hidden lg:flex lg:w-1/2 p-4">
        <div className="w-full h-full rounded-2xl overflow-hidden border shadow-2xl">
          <AuthSlideshow />
        </div>
      </div>
      
      {/* Right side - Auth Form */}
      <div className="flex-1 lg:w-1/2 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md">
          {children}
        </div>
      </div>
    </div>
  );
}